<script>
	import listBase from '@_system/components/base/list.vue'
	import footerIndex from './footer/index.vue'
	import payment from './payment/index.vue'
	import parcel from './parcel/index.vue'
	import supplierBox from './box/supplier.vue'
	import splitIndex from './split/index.vue'
	import batchreportForm from './form/batchreport.vue'
	import voucherForm from './form/voucher.vue'
	
	
	export default {
		extends: listBase,
		name: 'wlnpurchaseIndex',
		render(h) {
			this.$slots.mainheader = [
				<el-tag type="danger" size="mini">1分钟内同步</el-tag>,
				<el-switch style="padding-left:20px" v-model={this.showoutofstock} onChange={this.outofstockChange} active-text="显示缺货" inactive-text=""></el-switch>,
				<el-switch style="padding-left:20px" v-model={this.showClose} onChange={this.uncloseChange} active-text="显示关闭订单" inactive-text=""></el-switch>,
				<el-switch style="padding-left:20px" v-model={this.showFinish} onChange={this.unfinishChange} active-text="显示已完成" inactive-text=""></el-switch>,
				
			]
			this.$slots.footer = [
				<div style="position: relative;width: 100%;height:100%;">
					<footer-index componentStore={this.componentStore} currentRow={this.currentRow} toolbarButtonConfig={this.toolbarButtonConfig} toolbarButtonList={this.toolbarButtonList} ref="pricefluctuationsFooter" />
				</div>
			]
			this.$slots.plug = [
				<parcel ref="parcel" parcelForm={this.parcelForm} row={this.currentRow} onSubmit={this.submitParcel} />,
				<payment row={this.currentRow} list={this} paycode={this.paycode} ref="payment"  />,
				<supplier-box ref="supplierBox" onSubmit={this.supplierBoxSubmit} title={this.supplierBoxTitle} />,
				<split-index ref="splitIndex" row={this.currentRow} />,
				<batchreport-form ref="batchreportForm" row={this.currentRow}  onSubmit={this.submitBatchreport} />,
				<voucher-form ref="voucherForm" row={this.currentRow}  onSubmit={this.submitBatchreport} />,
			]
			return listBase.render.call(this, h)
		},
		props: {

		},
		data() {
			return {
				src:null,
				componentStore:{
					customreload:this.customreload,
					getcontent:this.getcontent
				},
				showoutofstock:false,
				showClose:false,
				showFinish:false,
				moduleName: 'wlnpurchase',
				windowName: '采购单',
				currentRow: {},
				selectrow:[],
				paycode: [],
				parcelForm:{
					createTime: null,
					billID: null,
					billCode: null,
					supplierID: null,
					supplierName: null,
					storageID: null,
					storageName: null,
					parcel: null,
					getday: null,
					remainday: null,
					pregettime: null,
				},
				supplierBoxTitle:'选择供应商'
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			voucher(row){
				//console.log(row)
				this.currentRow = row
				this.$refs.voucherForm.modal_show()
			},
			supplierBoxSubmit(e){
				this.loading = true
				this.$api.wlnpurchase.modifieddetail({
					billCode:this.currentRow.billCode,
					supplierName:e.data.name,
					supplierID:e.data.wlnid
				}).then(() => {
					this.loading = false
					this.$refs[this.moduleName + '_list'].commitProxy('query')
					this.$message.success('操作成功')
				},()=>{
					this.loading = false
				})
			},
			print(row) {
				this.currentRow = row
				this.$refs.splitIndex.modal_show()
			},
			workorder(item) {
				this.$api.flow.getSingleFlowTemplate(21).then((e) => {
					if (e) {
						let res = this.$router.resolve({
							name: 'add',
							query: {
								name: 'wlnpurchaseworkorder',
								id: 0,
								controlltype: 1,
								windowName: '非标工单',
								extra: JSON.stringify({
									billCode: item.billCode,
									billID: item.billID
								}),
								isflow: 1,
								flowid: 21
							}
						})
						if (this.device != 'pc') {
							this.$router.push(res.href.replace(/#/g, ''))
						} else {
							let win = window.open(res.href, item.formname + "add",
								this.$store.state.system.windowConfig)
							win.onload = () => {
								console.log(item.formname + 'form open')
							}
						}

					}
				})
			},
			autopullorders(){
				let synchronous = []
				let data = this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if(data.length==0){
					this.$message.error('请选择采购订单')
					return
				}
				data.forEach((item)=>{
					synchronous.push(this.synchronousHandle(item))
					
				})
				this.loading = true
				Promise.all(synchronous).then(()=>{
					this.customreload()
					this.loading = false
				})
			},
			
			synchronous(row){
				this.loading = true
				this.synchronousHandle(row).then(()=>{
					this.customreload()
					this.loading = false
				})
			},
			synchronousHandle(row){
				return new Promise((reslove)=>{					
					this.$api.wlnpurchase.synchronous({billCode:row.billCode}).then(()=>{
						reslove()
					},()=>{
						reslove()
					})
				})
			},
			beforeRender(){
				this.currentRow = null
			},
			beforeCreateGrid(formConfig,columns){
				columns.forEach((item)=>{
					if(item.field=='storageName'){
						item.slots = {
							default: ({row}) => {	
								let str= []
								if(row.urgent==1){
									str.push(<el-tag size="mini" type="primary" effect="dark" style="margin-right: 2px;">急</el-tag>)
								}
								if(row.takeMethod==1){
									str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">自</el-tag>)
								} 
								if(row.takeMethod==2){
									str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">送</el-tag>)
								}
								if(row.isoutofstock==1){
									str.push(<el-tag size="mini" type="info" effect="dark" style="margin-right: 2px;">缺</el-tag>)
								}
								str.push(<span>{row.storageName}</span>)
								return str
							}
						}
					}
				})
				
			},
			error(){
				this.$refs[this.moduleName + '_list'].commitProxy('query',{error:1})
			},
			submitParcel(){
				this.customreload()
			},
			payment(row) {
				this.currentRow = row
				this.$api.wlnpurchase.reportgoods({
					billID: row.billID,
					type: 'get'
				}).then(() => {
					this.paymentFlow()
				})	
			},
			paymentFlow() {
				this.$api.flow.getTotalFlowTemplate().then((res) => {
					let obj = res.find((item)=>{
						return item.id == 17
					})
					if(obj){
						this.open(obj)
					}else{
						this.$message.error('付款流程不存在')
					}
				})
			},
			open(item) {
				this.$api.flow.getSingleFlowTemplate(17).then((e) => {
					if (e) {
						let res = this.$router.resolve({
							name: 'add',
							query: {
								name: item.formname,
								id: 0,
								controlltype: 1,
								windowName: item.name,
								extra: JSON.stringify({
									componentname: item.componentname,
									billCode: this.currentRow.billCode,
									supplierID: this.currentRow.supplierID,
									supplierName: this.currentRow.supplierName
								}),
								isflow: 1,
								flowid: item.id
							}
						})
						if (this.device != 'pc') {
							this.$router.push(res.href.replace(/#/g, ''))
						} else {
							let win = window.open(res.href, item.formname + "add",
								this.$store.state.system.windowConfig)
							win.onload = () => {
								console.log(item.formname + 'form open')
							}
						}

					}
				})
			},
			uncloseChange(e){
				this.foreingKey.showclose = e?1:0
				this.customreload()
			},
			unfinishChange(e){
				this.foreingKey.showfinish = e?1:0
				this.customreload()
			},
			outofstockChange(e){
				this.foreingKey.outofstock = e?1:0
				this.customreload()
			},
			selfpickup(row){
				this.$api.wlnpurchase.updatefromlist(row.id,{
					takeMethod: 1
				}).then(() => {
					this.customreload()
				})	
			},
			submitBatchreport(e){
				this.loading = true
				let promiseArr = []
				let ids = []
				let data = this.selectrow
				data.forEach((item)=>{
					ids.push(item.billID)
				})
				this.$api.wlnpurchase.getDetail({ids:ids.join(',')}).then((res) => {
					let groupdata = this.$Lodash.groupBy(res, 'billID')
					data.forEach((item)=>{
						if(groupdata[item.billID]){
							let getcontent = this.getcontent(item,groupdata[item.billID],'reportgoods',e.modelimg == 1 ? true : false)

							// console.log(content)
							promiseArr.push(this.send(groupdata[item.billID],getcontent.text,item.supplierID))
						}
					})
					Promise.all(promiseArr).then(() => {
						this.loading = false
						this.customreload()
					}).catch(() => {
						this.loading = false
						this.customreload()
					})
							
				},()=>{
					this.loading = false
				})
			},
			reportbatchgoods(){
				let data = this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if(data.length==0){
					this.$message.error('请选择采购订单')
					return
				}
				this.selectrow = data
				this.$refs.batchreportForm.modal_show()

			},
			send(data,content,supplierid){
				return new Promise((reslove,reject)=>{
					this.$api.wlnpurchase.reportgoods({
						data: data,
						content: content,
						supplierid: supplierid,
						type: 'send',
						action: 'report'
					}).then(() => {
						reslove()
					},()=>{
						reject()
					})
				})
			},
			getcontent(row,detail,action = 'reportgoods',modelimg = false){
				let salesManName = row.salesManName
				if(salesManName){
					salesManName = salesManName.split('-')
					salesManName = salesManName[salesManName.length-1]
				}
				//console.log(salesManName, window.systemData.staff)
				let staffobj = window.systemData.staff.find((item)=>{
					return item.name == salesManName
				})
				//console.log(staffobj)
				let content = []
				let data = {
					title:"",
					detail:[],
					footer:"",
					notice:""
				}
				let type = '备货'
				let regex = /【(.*?)】/;
				let prochasestandardsRegex = /采购标准:([^|]+)/;
				detail.forEach((item) => {
					let match = item.remark?item.remark.match(regex):null
					let prochasestandardsMatch = item.remark?item.remark.match(prochasestandardsRegex):null						
					let size = parseInt(item.size)
					let unit = item.unitName ? item.unitName : '个'
					let dataobj = {
						code:item.skuCode,
						name:item.goodsName,
						model:item.skuName,
						size:size,
						unit:unit,
						modelimg:null,
						match:match ? `【${match[1]}】` : '',
						prochasestandards:prochasestandardsMatch ? `【${prochasestandardsMatch[1]}】` : '',
						bargain:""
					}		
					if(action=='bargain'){
						dataobj.bargain = ' 有货吗？最低价格多少？'
					}
					if(modelimg){
						let modelimg_file = item.modelimg_file ? item.modelimg_file :[]
						modelimg_file = modelimg_file.map((fileitem)=>{
							let _fileitem = fileitem.path.replace(window.config.oss.aliyun_domain,window.config.oss.custom_domain)
							return _fileitem.replace('https','http')
						})
						modelimg_file =  modelimg_file.join(',')
						if(modelimg_file){
							dataobj.modelimg_file = modelimg_file
						}
							
					}
					if(item.goodsName.indexOf('运费')===-1){
						data.detail.push(dataobj)			
					}
							
				})

				if(action=='reportgoods'){
					if (row.remark && row.remark.includes('应急')) {
						data.title = '#应急单#'
						type = '应急'
					}else{
						data.title = '#备货单#'
					}
					data.footer = '开单发群里  缺货请告知  单随货发 否则拒收  麻烦单据备注【' + row.storageName.replace(/[^\u4e00-\u9fa5]/g, '') +
						type +
						'】+' + row.billCode.slice(-6)


					let noticestr = '开单或缺货请及时'	
					if (type == '应急') {
						noticestr = '注：应急货品请16：00前给我们，缺货请及时'				
					}
					if(staffobj){
						noticestr += ' @'+staffobj.nickname+' 告知'				
					}else{
						noticestr += '告知'				
					}
					data.notice = noticestr
				}
				
				content.push(data.title)
				data.detail.forEach((item)=>{
					let goodsitem = item.name + ' ' + item.model + '【' + item.size + ' '+ item.unit +'】' + item.bargain + item.match + item.prochasestandards
					content.push(goodsitem)
				})
				content.push("")
				content.push(data.footer)
				content.push(data.notice)			
				return {
					data:data,
					text:content.join('\n')
				}
			},
			homedelivery(row){
				this.$api.wlnpurchase.updatefromlist(row.id,{
					takeMethod: 2
				}).then(() => {
					this.customreload()
				})
			},
			urgent(row){
				this.$api.wlnpurchase.updatefromlist(row.id,{
					urgent: 1
				}).then(() => {
					this.customreload()
				})
			},
			cellClick(e) {
				if (e.column.field) {
					this.currentRow = e.row
				}
				
			},
			cellDblclick({
				row,
				column
			}) {
				this.currentRow = row
				if (column.field.indexOf('parceltype') !== -1) {
					this.parcelForm = {
						createTime:row.createTime * 1000,
						billID:row.billID,
						billCode:row.billCode,
						supplierID:row.supplierID,
						supplierName:row.supplierName,
						storageID:row.storageID,
						storageName:row.storageName,
						parcel:row.parceltype,
						getday:row.getday,
						remainday:row.remainday,
						pregettime:row.pregettime?row.pregettime*1000:null,
					}
					this.$refs.parcel.show = true
				}
				if (column.field.indexOf('supplierName') !== -1) {

					this.$refs.supplierBox.box.initList()
					this.$refs.supplierBox.box.alertBox()
				}

			},			
			cellStyle({
				row,
				column
			}) {
				let map = {
					status:{
						1:'#F56C6C',
						2:'#409EFF',
						3:'#67C23A',
					},
					reportStatus:{
						0:'#F56C6C',
						1:'#67C23A',
						2:'#409EFF',
					},
					bargainStatus:{
						0:'#F56C6C',
						1:'#67C23A',
						2:'#409EFF',
					},
					takeStatus:{
						0:'#F56C6C',
						1:'#67C23A',
						2:'#409EFF',
					},
					paymentStatus:{
						0:'#F56C6C',
						1:'#67C23A',
						2:'#409EFF',
						3:'#909399',
					}
				}
				if (column.property && column.property.indexOf('parceltype') !== -1) {
					return {
						backgroundColor: 'rgb(240, 249, 235)'
					}
				}
				if (column.property && column.property.indexOf('supplierName') !== -1) {
					return {
						backgroundColor: 'rgb(240, 249, 235)'
					}
				}
				if (row.grabstatus == 8113) {
					return {
						backgroundColor: 'rgb(233, 233, 235)'
					}
				}
				if(map[column.field]){
					return {
						color: map[column.field][row[column.field]]
					}
				}

			},
		},
		components: {
			footerIndex,
			payment,
			parcel,
			supplierBox,
			splitIndex,
			batchreportForm,
			voucherForm
		}
	}
</script>